import { Heading, Button } from '@ctct/payflow-ui';

import './page-error.scss';

interface Props {
  heading: string;
  description?: string;
  retry?: {
    fn: () => void;
    label: string;
  };
}

export const PageError = ({ heading, description, retry }: Props) => {
  return (
    <div className="presentation-layer-page-error">
      <div className="presentation-layer-page-error__image">
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
          alt="error"
        />
      </div>
      <div>
        <Heading level="h6-xs" className="presentation-layer-page-error__heading">
          {heading}
        </Heading>
        <p className="presentation-layer-page-error__description">{description}</p>
      </div>
      {retry && (
        <div className="presentation-layer-page-error__actions">
          <Button onClick={retry.fn}>{retry?.label}</Button>
        </div>
      )}
    </div>
  );
};
